import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectDeliveryWizardData = createSelector(
    (state: RootState) => state.deliveryWizard,
    deliveryWizard => deliveryWizard
);

export const selectIsDeliveryWizardShortEdit = createSelector(
    (state: RootState) => state.deliveryWizard.isShortEdit,
    isShortEdit => isShortEdit
);

export const selectDeliveryWizardStep = createSelector(
    (state: RootState) => state.deliveryWizard.deliveryWizardStep,
    deliveryWizardStep => deliveryWizardStep
);

export const selectSelectedAdvertiser = createSelector(
    (state: RootState) => state.deliveryWizard.selectedAdvertiser,
    selectedAdvertiser => selectedAdvertiser
);

export const selectSelectedBrand = createSelector(
    (state: RootState) => state.deliveryWizard.selectedBrand,
    selectedBrand => selectedBrand
);

export const selectSelectedMediaCompany = createSelector(
    (state: RootState) => state.deliveryWizard.selectedMediaCompany,
    selectedMediaCompany => selectedMediaCompany
);

export const selectSelectedProductionCompany = createSelector(
    (state: RootState) => state.deliveryWizard.selectedProductionCompany,
    selectedProductionCompany => selectedProductionCompany
);
export const selectSelectedPostProductionCompanyId = createSelector(
    (state: RootState) => state.deliveryWizard.delivery.PostProductionCompanyId,
    PostProductionCompanyId => PostProductionCompanyId
);

export const selectSelectedIndustry = createSelector(
    (state: RootState) => state.deliveryWizard.selectedIndustry,
    selectedIndustry => selectedIndustry
);

export const selectAllBrandsFromCache = createSelector(
    (state: RootState) =>  state.jumboMediaAPI.queries['getAllBrandsFull({"asSelectOptions":false})'],
    brands => brands.data,
);

export const selectAllIndustriesFromCache = createSelector(
    (state: RootState) =>  state.jumboMediaAPI.queries['getAllIndustries({"asSelectOptions":false})'],
    industries => industries.data,
);
